export default class MemberDetailComponentController {
  constructor($sce) {
    'ngInject';

    this.attributeLengthMultiplicator = 22; // hack since safari has bug with flex-wrap(https://bugs.webkit.org/show_bug.cgi?id=136041)
    this.$sce = $sce;
  }

  $onInit() {
    const description = this.member.description || 'N/A';
    this.member.trustedDescription = this.$sce.trustAsHtml(description.trim());
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/members/screens/member-detail/member-detail.controller.js